const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

export const API_ROUTES = {
  SITE_STATE: `${API_BASE_URL}/site-state`,
  SITE_STATE_VALIDATE: `${API_BASE_URL}/site-state/validate`,
  REGISTER: `${API_BASE_URL}/auth/register`,
  LOGIN: `${API_BASE_URL}/auth/login`,
  GENERATOR: `${API_BASE_URL}/generator`,
  RECIPES: {
    LIST: `${API_BASE_URL}/recipes`,
    GENERATE: `${API_BASE_URL}/recipes/generate`,
  },
  VERIFY_EMAIL: `${API_BASE_URL}/verify-email`,
};
